export enum ViewPart {
  LeftMenu = 1,
  LeftPanel = 2,
  Toolbar = 3,
  Footer = 4,
  Devices = 5,
  RightPanel = 6,
  RightMenu = 7,
  ScreensPanel = 8,
  ComponentsPanel = 9,
  DatasourcesPanel = 10,
  CodeTreePanel = 11,
  DisplayItemTreePanel = 12,
  PropertiesPanel = 13,
  StylingPanel = 14,
  DocumentsPanel = 15,
  CommentsPanel = 16,
  HistoryPanel = 17,
  ScreensButton = 18,
  ComponentsButton = 19,
  DatasourcesButton = 20,
  DisplayItemTreeButton = 21,
  PropertiesButton = 23,
  StylingButton = 24,
  DocumentsButton = 25,
  CommentsButton = 26,
  HistoryButton = 27,
  SaveButton = 28,
  UndoRedo = 29,
  Phone = 30,
  Tablet = 31,
  Desktop = 32,
  PreviewButton = 33,
  DesignButton = 35,
  ShareButton = 36,
  SendApproveButton = 37,
  ApproveButton = 38,
  SaveAndSaveAsMenuItems = 39,
  ExportPngMenuItem = 40,
  ExportKuikaFileMenuItem = 41,
  DesignCanvas = 42,
  MetadataViewer = 44,
  RemoveScreenContentButton = 45,
  VersiyonInfo = 46,
  SortCutList = 47,
  Zoom = 48,
  BreadCrumb = 49,
  ImageLibraryButton = 50,
  ImageLibraryPanel = 51,
  LanguageButton = 52,
  LanguagePanel = 53,
  DataDiagramSchemeButton = 54,
  DataDiagramSchemePanel = 55,
  WorkFlowButton = 56,
  WorkFlowDesign = 57,
  WorkFlowListPanel = 58,
  SdPropertiesPanel = 59,
  WfPropertiesPanel = 60,
  WorkFlowFieldListPanel = 61,
  WorkFlowListButton = 62,
  WorkFlowFieldListButton = 63,
  DatasourcePropertiesPanel = 64,
  DesignerButton = 65,
  ConfigManagerButton = 66,
  ConfigManagerPanel = 67,
  NotificationTemplateButton = 68,
  NotificationTemplatePanel = 69,
  ScheduledJobsButton = 70,
  ScheduledJobsPanel = 71,
  ScheduledJobsPropertiesPanel = 72,
  ApiManagementButton = 73,
  ApiManagementPanel = 74,
  ApiManagementPropertiesPanel = 75,
  ZendeskButton = 76,
  ZendeskPanel = 77,
  ZendeskPropertiesPanel = 78,
  ReportDesignerButton = 79,
  ReportDesignerPagesPanel = 80,
  ReportDesignerPropertiesPanel = 81,
  ReportsButton = 82,
  RolePanel = 83,
  AuthorizationPanel = 84,
  PressEnterPanel = 85,
  ValidationPanel = 86,
  ExploreDocumentationPanel = 87,
  ConfigExploreDocumentationPanel = 88,
  NotificationExploreDocumentationPanel = 89,
  ScheduledJobsExploreDocumentationPanel = 90,
  ApiManagementExploreDocumentationPanel = 91,
  WorkflowExploreDocumentationPanel = 92,
  ReportDesignerExploreDocumentationPanel = 93,
  NotificationTemplatePropertiesPanel = 94,
  ScheduledJobsPanelButton = 95,
  ApiManagementPanelButton = 96,
  ChatbotButton = 97,
  ChatbotPanel = 98,
  ActionTreeButton = 99,
  ActionTreePanel = 100,
  BluetoothPropertiesPanel = 101,
  BluetoothDatasourceExploreDocumentationPanel = 102,
  WorkflowRightPanel = 103,
  HappyPathButton = 104,
  HappyPathPropertiesPanel = 105,
  FooterBreadcrumb = 106,
  ReportSizesDropdown = 107,
  WorkflowVersionButton = 108,
  WorkflowVersionPropertiesPanel = 109,
  ButtonsPanel = 110,
  ButtonsPanelButton = 111,
  AuditButton = 112,
  Audit = 113,
  CustomAITemplatePropertiesPanel = 114,
  AIChatLeftPanel = 115,
  AIChatRightPanel = 116,
  BranchingPanelButton = 117,
  BranchingPanel = 118,
  DocumentParametersButton = 119,
  DocumentParametersPanel = 120,
  DocumentParametersPanelButton = 121,
  DocumentParametersPropertiesPanel = 122,
  /**
   * The toolbar under the primary one, carrying whatever the open dashboard needs to
   * switch and navigate (process/screen/report switcher, the process tabs, the device and
   * page-size dropdowns). Appended, so no existing value shifts.
   */
  SecondaryToolbar = 123
}
